// ============================================================
// SV Audio Player — Mobile bar UI
// ============================================================
//
// This module owns DOM manipulation for:
// - the mobile bottom bar
// - the mobile title marquee behavior
// Mobile bottom bar only:
// - building the bar
// - title marquee behavior
/**
 * Debug helper for mobile UI.
 * If you already have a similar helper elsewhere, it's fine to
 * duplicate it here for now.
 */
function svDebug(tag, payload) {
  try {
    const enabled =
      typeof window !== "undefined" && window.__SV_DEBUG__ === true;
    if (!enabled) return;
    // eslint-disable-next-line no-console
    console.log("[SVDEBUG]", tag, payload);
  } catch {
    // never throw from debug
  }
}

function wrapSeekBar() {
  const seek = document.querySelector(".seek-bar-container");
  const time = document.querySelector(".time-display");

  if (!seek || !time) return;
  if (document.querySelector(".seek-wrapper")) return;

  const wrapper = document.createElement("div");
  wrapper.className = "seek-wrapper";

  if (!seek.parentNode) return;

  seek.parentNode.insertBefore(wrapper, seek);
  wrapper.appendChild(seek);
  wrapper.appendChild(time);
}

// ------------------------------------------------------------
// Exported mobile helpers
// ------------------------------------------------------------

export function refreshMobileTitleMarquee() {
  const outer = document.querySelector("[data-sv-mobile-title-outer]");
  if (!outer) return;

  const trackEl = outer.querySelector(".mobile-title-track");
  const primaryText = outer.querySelector(
    ".mobile-title-text:not(.mobile-title-text--clone)"
  );

  if (!trackEl || !primaryText) return;

  // Reset transform so measurement uses the natural width
  trackEl.style.transform = "";

  const measure = () => {
    const needsScroll = primaryText.scrollWidth > outer.clientWidth;
    outer.classList.toggle("is-marquee", needsScroll);
  };

  if (typeof window !== "undefined" && window.requestAnimationFrame) {
    window.requestAnimationFrame(measure);
  } else {
    measure();
  }
}

export function initMobileBar({
  expandHandle,
  prevBtn,
  playPauseBtn,
  nextBtn,
  toggleExpanded,
}) {
  if (window.innerWidth > 768) return; // only on mobile-ish widths

  if (document.querySelector(".mobile-bar")) {
    console.log("[Player] initMobileBar: already present, skipping");
    return;
  }

  console.log("[Player] initMobileBar: building mobile bar");

  wrapSeekBar();

  const controlsContainer = document.querySelector(".player-controls");
  if (!controlsContainer) {
    console.warn("[Player] initMobileBar: .player-controls not found");
    return;
  }

  // OPTIONAL hints only; fine if these are null on /music
  const titleEl = document.getElementById("songTitle");
  const artEl = document.getElementById("albumArt");

  const initialTitle =
    (titleEl && titleEl.textContent && titleEl.textContent.trim()) ||
    "Nothing playing";

  const mobileBar = document.createElement("div");
  mobileBar.className = "mobile-bar";

  mobileBar.innerHTML = `
        <div class="mobile-left">
          <img
            class="mobile-art"
            alt=""
            data-sv-player-art
            loading="lazy"
            decoding="async"
          />
          <div class="mobile-title-outer" data-sv-mobile-title-outer>
            <div class="mobile-title-track">
              <span class="mobile-title-text" data-sv-player-title>
                ${initialTitle}
              </span>
              <span
                class="mobile-title-text mobile-title-text--clone"
                data-sv-player-title
              >
                ${initialTitle}
              </span>
            </div>
          </div>
        </div>
        <div class="mobile-controls"></div>
      `;

  controlsContainer.appendChild(mobileBar);

  const mobileControls = mobileBar.querySelector(".mobile-controls");

  if (mobileControls) {
    if (prevBtn) mobileControls.appendChild(prevBtn);
    if (playPauseBtn) mobileControls.appendChild(playPauseBtn);
    if (nextBtn) mobileControls.appendChild(nextBtn);
  }

  // If we DO have hero art (e.g. on a song page), seed the img src.
  const mobileArtImg = mobileBar.querySelector(".mobile-art");
  if (mobileArtImg && artEl && artEl.src) {
    mobileArtImg.src = artEl.src;
  }
  // Otherwise on /music we leave src unset; SVPlayer will fill it later.

  if (expandHandle) {
    expandHandle.classList.add("mobile-expand-handle");
    mobileBar.appendChild(expandHandle);
  }

  function bounceMobileBar() {
    mobileBar.classList.add("tap-bounce");
    setTimeout(() => mobileBar.classList.remove("tap-bounce"), 120);
  }

  function shouldIgnoreTap(target) {
    return target.closest(".mobile-controls");
  }

  function handleBarClick(event) {
    const target = event.target;
    if (!target) return;
    if (shouldIgnoreTap(target)) return;

    bounceMobileBar();

    if (typeof toggleExpanded === "function") {
      toggleExpanded("mobile-bar-click");
    }
  }

  mobileBar.addEventListener("click", handleBarClick);

  // NEW: if we already have a current track (e.g., coming from resize),
  // immediately sync the UI into this freshly built bar.
  if (
    window.SVPlayer &&
    typeof window.SVPlayer.syncNowPlayingUi === "function"
  ) {
    window.SVPlayer.syncNowPlayingUi();
  }

  // NEW:
  refreshMobileTitleMarquee();
}